import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import {Grid, ListItem, Box} from '@material-ui/core'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress'
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import Button from '../../components/ButtonCustom';
import Divider from '../../components/Divider';
import { MasterIcon, RadioCheckedIcon, RadioIcon, VisaIcon } from '../../components/icons';
import { LinkRouter } from '../../components/Link';
const styles = theme => ({
    container:{
        padding: theme.spacing(6),
    },
    item:{
        marginTop:theme.spacing(4),
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
    },
    form:{
        marginTop: theme.spacing(32)
    },
    boxItemContent: {
        padding: theme.spacing(3,4,3,4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
    btn_topup:{
        marginTop: theme.spacing(16)
    },
    card_item: {
        width: '100%',
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.border.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },

    last: {
        width: '100%',
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },

});
function AutomateWalletView(props) {
        const { automateInfo, classes, onClose,showLoading} = props;
        //console.log('automateInfo=====', automateInfo)
        return (
            <DrawerCustom 
                open={props.open} 
                onClose = {onClose} 
                title = {t('auto_topup_title')}
                children={        
                    <Grid item>
                        {showLoading?<Grid xs ={12} item container justify='center'><CustomizedCircularProgress color="primary"/></Grid>:null}

                        <Form 
                            onSubmit={props.onAutomateWallet}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item className={classes.form}>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="wallet_balance_threshold"
                                            component={TextFieldComponent}
                                            label={t('auto_topup_desc_1')}
                                            placeholder={t('0.00')}
                                            isEdit={true}
                                            color='default'
                                            valuez = {automateInfo.wallet_balance_threshold}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                            onCustomChange={(text)=>props.onChangeInputAutoWallet('wallet_balance_threshold', text)}
                                            endAdornment={<LinkRouter type='body2' size='sm' color='primary' onClick = {()=>props.onChangeInputAutoWallet('wallet_balance_threshold', ' ')}>{t('reset')} </LinkRouter>}
                                            
                                        />
                                    </Grid>
                                    <Grid xs={12} item container>
                                        <Field
                                            name="top_up_amount"
                                            component={TextFieldComponent}
                                            label={t('auto_topup_desc_2')}
                                            placeholder={t('0.00')}
                                            isEdit={true}
                                            color='default'
                                            valuez = {automateInfo.top_up_amount}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                            onCustomChange={(text)=>props.onChangeInputAutoWallet('top_up_amount', text)}
                                            endAdornment={<LinkRouter type='body2' size='sm' color='primary' onClick = {()=>props.onChangeInputAutoWallet('top_up_amount', ' ')}>{t('reset')} </LinkRouter>}
                
                                        />
                                    </Grid>
                                     
                                    

                                    <Grid xs={12} item container justify='center' className={classes.btn_topup}>
                                        <Button color='primary' fullWidth onClick={handleSubmit} id="btn_topup_auto_submit">{t('btn_submit')}</Button>
                                    </Grid>
                                </Grid>
                            )} />
                        {/* <Grid item xs={12} className={classes.form}>
                            <Form
                            onSubmit={props.onSubmitAutomateWallet}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid item xs={12}>
                                    <Grid xs={12} item textAlign="center"> 
                                        <CustomTypo color='onPrimary' variant='body1' center>{t('automatically_topup')}</CustomTypo>
                                    </Grid>
                                    <Grid xs={12} item paddingTop={3}>
            
                                        <CustomTypo color='onPrimary' variant='body1' center>{t('when_amount_below')}</CustomTypo>
                                        <Field
                                            fullWidth
                                            name="wallet_balance_threshold"
                                            component={TextFieldComponent}
                                            defaultValue={automateInfo && automateInfo.wallet_balance_threshold ? automateInfo.wallet_balance_threshold :'0'}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                            color="primary"
                                            endAdornment={<Grid item 
                                                style={{cursor: 'pointer'}} 
                                                onClick={() => props.handleChangeInput("wallet_balance_threshold")} 
                                                color="primary">{t('rest')}
                                            </Grid>}
                                        />
                                    </Grid>
                                    <Grid xs={12} item paddingTop={3}>
                                    <CustomTypo color='onPrimary' variant='body1' center>{t('add_amount')}</CustomTypo>
                                        <Field
                                            fullWidth
                                            name="top_up_amount"
                                            defaultValue={automateInfo && automateInfo.top_up_amount ? automateInfo.top_up_amount : '0'}
                                            component={TextFieldComponent}
                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                            color="primary"
                                            endAdornment={<Grid item 
                                                style={{cursor: 'pointer'}} 
                                                onClick={() => props.handleChangeInput("top_up_amount")} 
                                                color="primary">{t('rest')}
                                            </Grid>}
                                        />
                                    </Grid>
                                    <Grid xs={12} item marginTop={5}>
                                        <Box padding={1} paddingTop={3} flex={1}>
                                            <Button variant="contained" color="secondary" fullWidth onClick={handleSubmit} className={classes.button}>{t('btn_submit')}</Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
            />
        </Grid> */}
                    </Grid>
                }/>
        );
}

export default withStyles(styles)(withTranslation()(AutomateWalletView));